import { Component, OnInit, ViewChild } from '@angular/core';
import { GridViewComponent } from 'src/app/shared/components/grid-view/grid-view.component';
import { Listing } from 'src/app/shared/models/listing.model';
import { MenuItem } from '../../e-booking/agent-registration-request/offline-agent-list/offline-agent-list.component';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { Languages } from 'src/app/shared/models/enums.model';
import { EtenderEvaluationService } from 'src/app/shared/services/etenderEvaluation.service';
import { EtenderService } from 'src/app/shared/services/etender.service';
import { ETenderAdminTypes } from 'src/app/shared/models/e-tender.model';
import { AppConfig } from 'src/app/shared/services/app.config';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-etender-supplier-evaluation-list',
  templateUrl: './etender-supplier-evaluation-list.component.html',
  styleUrls: ['./etender-supplier-evaluation-list.component.css']
})
export class EtenderSupplierEvaluationListComponent implements OnInit {
  private collection: Listing;
  @ViewChild('EtenderSupplier',{static: false}) gridView: GridViewComponent;
  HasMenu = true;
  hideExportButton: boolean;
  private itemsMenu: MenuItem[] = [];
  displayedLang: string;
  pageSize = 10;
  tenderName = '';
  supplierName = '';
  fileNumber = '';
  supplierResponse?: boolean = null;
  involvedSupplier?: boolean = null;
  isQualified?: boolean = null;
  isHighPrice?: boolean = null;
  isWinner?: boolean = null;
  currentUser: string;
  SupplierNumber: string;

  constructor(private global: GlobalServices, private etenderService: EtenderEvaluationService,
              private translate: TranslateService, private authSrevice: AuthenticationService,
              private router: Router) {
    this.displayedLang = this.global.getLanguage() == Languages.Arabic ? 'ar' : 'en';
    this.currentUser = this.authSrevice.currentUserValue.Email;
    if (history.state.data && history.state.data.FileNumber) {
    this.fileNumber = history.state.data.FileNumber;
    }
    // this.currentUser = this.global.user.Email;

  }

  ngOnInit() {
    this.loadData();
  }
  ExportExcel() {
    this.translate.get('SHARED.REPORTS.ETENDER_SUPPLIER_EVALUATION_OBJECT').subscribe((response: string) => {
      const ExportExcelUrl = AppConfig.settings.apiServer.apiUrl +
        'ETenderSupplierEvaluation/ExportETenderEvaluationReportExcel?eTenderEvaluationObject=' + JSON.stringify(response) +
        '&language=' + (this.global.getLanguage() == Languages.Arabic ? 'Ar' : 'En') + '&tenderName=' + this.tenderName +
        '&supplierName=' + this.supplierName + '&supplierResponse=' + this.supplierResponse + '&involvedSupplier=' + this.involvedSupplier +
        '&isQualified=' + this.isQualified + '&isHighPrice=' + this.isHighPrice + '&isWinner=' + this.isWinner +
        '&currentUser=' + this.currentUser + '&supplierNumber=' + this.SupplierNumber  + '&fileNumber=' + this.fileNumber;
      window.open(ExportExcelUrl, '_self');
    });
  }


  loadCollectionCompleted() {
    this.gridView.loadGrid(this.collection, this.collection == null ? 0 : this.collection.TotalNumber, this.pageSize,
      'ETenderSupplierEvaluation/getETenderEvaluationReport?pageIndex={PAGEINDEX}&pageSize=' + this.pageSize +
      '&language=' + (this.global.getLanguage() == Languages.Arabic ? 'Ar' : 'En')
      + '&tenderName=' + this.tenderName + '&supplierName=' + this.supplierName
      + '&supplierResponse=' + this.supplierResponse + '&involvedSupplier=' + this.involvedSupplier
      + '&isQualified=' + this.isQualified + '&isHighPrice=' + this.isHighPrice + '&isWinner='
      + this.isWinner + '&currentUser=' + this.currentUser + '&SupplierNumber=' + this.SupplierNumber
      + '&fileNumber=' + this.fileNumber ,
      'SHARED.REPORTS.ETENDER_SUPPLIER_EVALUATION_OBJECT', this.itemsMenu, '', '', '');
    this.global.isLoaderEnabled = false;
  }

  loadData() {
    this.tenderName = this.tenderName == null ? '' : this.tenderName;
    this.supplierName = this.supplierName == null ? '' : this.supplierName;
    if (this.supplierResponse != null) {
      this.supplierResponse = this.supplierResponse;
    } else {
      this.supplierResponse = null;
    }
    if (this.involvedSupplier != null) {
      this.involvedSupplier = this.involvedSupplier;
    } else {
      this.involvedSupplier = null;
    }
    if (this.isQualified != null) {
      this.isQualified = this.isQualified;
    } else {
      this.isQualified = null;
    }
    if (this.isWinner != null) {
      this.isWinner = this.isWinner;
    } else {
      this.isWinner = null;
    }
    this.SupplierNumber = this.SupplierNumber == null ? '' : this.SupplierNumber;
    this.fileNumber = this.fileNumber == null ? '' : this.fileNumber;
    this.global.isLoaderEnabled = true;
    this.etenderService.GetTenderSupplierEvaluationList(0, this.pageSize,
      (this.global.getLanguage() == Languages.Arabic ? 'Ar' : 'En'), this.tenderName, this.supplierName,
      this.supplierResponse, this.involvedSupplier, this.isQualified, this.isHighPrice, this.isWinner,
      this.currentUser, this.SupplierNumber, this.fileNumber).subscribe(
        d => {
          this.collection = d.Data;
          this.hideExportButton = this.collection.Collection.length > 0 ? false : true;
        },
        () => console.log('Something went wrong!!'),
        () => this.loadCollectionCompleted()

      );
  }

  // reset filteration data

  resetData() {
    this.tenderName = '';
    this.supplierName = '';
    this.supplierResponse = null;
    this.involvedSupplier = null;
    this.isQualified = null;
    this.isHighPrice = null;
    this.isWinner = null;
    this.SupplierNumber = '';
    this.fileNumber = '';
    this.loadData();
  }
  View(fileNumber) {
    if (fileNumber) {
      this.router.navigate(['/CreateTender'], { state: { data: { FileNumber: fileNumber} } });
    }
  }

}
